module.exports = __webpack_public_path__ + "images/application/i-beacon-f51610ab.svg";